import { apiClient } from './client'

// Types matching backend schemas (src/schemas/feedback.py)

export type FeedbackType = 'positive' | 'negative'

export interface FeedbackFilterConfig {
  jurisdictions: { uuid: string; name: string }[]
  pub_authorities: { uuid: string; name: string }[]
  documents: { legislation_uuid: string; title: string }[]
}

export interface FeedbackCreate {
  conversation_id: number
  message_id: number
  feedback_type: FeedbackType
  feedback_text?: string | null
  filter_config?: FeedbackFilterConfig | null
}

export interface FeedbackResponse {
  id: number
  conversation_id: number
  message_id: number
  feedback_type: FeedbackType
  created_at: string
}

/**
 * Submit feedback (thumbs up/down) on a bot response.
 * POST /api/v1/feedback/
 */
export async function submitFeedback(
  data: FeedbackCreate,
): Promise<FeedbackResponse> {
  const response = await apiClient.post<FeedbackResponse>(
    '/api/v1/feedback/',
    data,
  )
  return response.data
}
